var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg01EquiposSelect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19.14 19.13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M424.37,203a9.36,9.36,0,0,0-5.91-4,7.9,7.9,0,0,0-.83-.12l-.39-.05-.12,0-.07,0h-1.12l-.34.05-.74.1a9.62,9.62,0,0,0-7.88,8.46l0,.27v1.25c0,.12,0,.23,0,.35s.06.49.11.74a9.4,9.4,0,0,0,3.38,5.76,9.2,9.2,0,0,0,5.06,2.11c.35,0,.69,0,1,0a9.56,9.56,0,0,0,7.83-15Zm-16.24,4.8a8.31,8.31,0,0,1,1.63-4.39,8.31,8.31,0,0,1,1.61,4.39Zm7.77,1.2v7.76a8.33,8.33,0,0,1-5.35-2.45,9.72,9.72,0,0,0,2-5.31Zm0-8.94v7.74h-3.34a9.61,9.61,0,0,0-2-5.29A8.3,8.3,0,0,1,415.9,200ZM411.37,209a8.3,8.3,0,0,1-1.61,4.4,8.4,8.4,0,0,1-1.63-4.4Zm13.49-1.2h-3.24a8.35,8.35,0,0,1,1.61-4.39A8.33,8.33,0,0,1,424.86,207.78Zm0,1.2a8.28,8.28,0,0,1-1.63,4.39,8.25,8.25,0,0,1-1.61-4.39Zm-7.76-1.2V200a8.32,8.32,0,0,1,5.34,2.45,9.72,9.72,0,0,0-2,5.31Zm3.33,1.2a9.67,9.67,0,0,0,2,5.3,8.39,8.39,0,0,1-5.34,2.45V209Z",
    transform: "translate(-406.93 -198.81)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg01EquiposSelect);
export default __webpack_public_path__ + "static/media/01_Equipos_Select.c140df6b1d71b4cd9dd34f117b20adc2.svg";
export { ForwardRef as ReactComponent };